import { handleGenericApiError } from "app/api/error";
import InvoiceRequests from "app/api/invoice";
import PaymentRequests from "app/api/payment";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_PAYMENT_DISCHARGE =
  "payment:ACTION_SAVE_PAYMENT_DISCHARGE";
export const ACTION_SAVE_JOB_MATERA_SETTLEMENT_HISTORY =
  "payment:ACTION_SAVE_JOB_MATERA_SETTLEMENT_HISTORY";
export const ACTION_SAVE_INVOICE_COMPENSATION =
  "payment:ACTION_SAVE_INVOICE_COMPENSATION";

export const fetchPaymentDischarge = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await PaymentRequests.fetchPaymentDischarge(params);
    dispatch({ type: ACTION_SAVE_PAYMENT_DISCHARGE, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchJobMateraSettlementHistory = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await PaymentRequests.fetchJobMateraSettlementHistory(params);
    dispatch({
      type: ACTION_SAVE_JOB_MATERA_SETTLEMENT_HISTORY,
      payload: data,
    });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchInvoiceCompensation = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data =
      await InvoiceRequests.fetchInvoiceCompensationDashboard(params);
    dispatch({
      type: ACTION_SAVE_INVOICE_COMPENSATION,
      payload: data,
    });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
